import { CanLoad, Router, UrlTree } from '@angular/router';
import { UserPermissionsService } from '@cpak/main-features-lib/services';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MaintenanceGuard implements CanLoad {
  constructor(private userPermissionsService: UserPermissionsService, private router: Router) {}

  canLoad(): Observable<true | UrlTree> {
    return this.userPermissionsService
      .hasSomeMaintenancePermission()
      .pipe(map(hasPermission => hasPermission || this.router.createUrlTree(['/'])));
  }
}
